const ImageSmartBoxLink = 'https://moje.o2.cz/document-direct/?path=react%2Fsmart_box&site=o2';

export default ImageSmartBoxLink;
